<template>
  <div class="row align-items-center">
    <div class="" v-for="(post, index) in posts" :key="index">
        <div class="card-row" :style="homeBanner" v-if="index == indexBanner || index == 6">
            <div class="col-12">
                <img src="https://api.belladasemana.com.br/storage/banners/1711982187.webp" alt="Banner" />
            </div>
        </div>
        <div class="card-row" v-else>
          <div class="col-5" :style="backColor">
            <img 
              width="157"
              height="133"
              :src="`${post.cover}`" :alt="post.title" 
            />
          </div>
          <div class="col-7" :style="backColor">
            <router-link
              :to="{
                    name: 'ColumnSingle',
                    params: { 
                      locale: this.locale,
                      catergoriaId: post.tag_id,
                      categoriaName: post.slugCategory,
                      colunaId: post.id,
                      colunaName: post.slug
                    }
              }"
              class="button--more"
            >
              <p>
                <span class="card-category">{{ post.category }}</span>
              </p>
              <div class="card-title">{{ post.title }}</div>
              <p></p>
              <p
                class="card-text"
                v-for="description in post.meta_description"
                :key="description.language_id"
              >
                <span
                  v-if="description.language_id === 1 && locale === 'pt-br'"
                  v-text="description.content"
                ></span>
                <span
                  v-if="description.language_id === 2 && locale === 'en'"
                  v-text="description.content"
                ></span>
              </p>
            </router-link>                              
          </div>
        </div>
        <hr style="background-color: black" :style="(index == 1 && this.$route.name == 'homePage') ? homeBanner : ''"/>        
    </div>
  </div>
</template>
  
<script lang="ts">
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import translateMain from 'tradutors/menu'

export default {
    name: 'CardsMobile',
    props: ['posts'],
    computed: {
        ...mapState(localeStore, ['locale']),
        translateMain: function () {
            if (this.locale === 'pt-br') {
            return translateMain.portugues
            } else {
            return translateMain.ingles
            }
        },
        image() {
            return `${this.$root.baseUrl}/storage/blog/${this.post.cover}`
        },
        findImage(file) {
            return `${this.$root.baseUrl}/storage/blog/${file}`
        }
    },
    data() {
      return {
        indexBanner: 2,
        homeBanner: '',
        backColor: ''
      }
    },
    created() {
      if (this.$route.name == "ColumnsPage") {
        this.indexBanner =  2
        this.backColor = {backgroundColor: '#FFFFFF'}
      } else {
        this.indexBanner =  2
        this.homeBanner = {display: 'none'}
        this.backColor = {backgroundColor: '#f6f8fb'}
      }
    },
    methods: {}
}
</script>
<style scoped>
  .card-title {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 21px;
    padding: 0 10px;
  }

  .card-text {
    color: #5b5858;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    padding: 0 10px;
  }

  .card-text span{
    font-family: 'Roboto-Regular';
  }

  .button--more svg {
    color: #b20000;
  }

  .button--more {
    font-family: 'Exo-2';
    font-weight: bold;
  }

  .small svg {
    margin-right: 5px;
  }

  .card-row img {
    width: 100%;
    object-fit: cover;
    height: auto;
  }
  .card-row {
    background-color: var(--bs-white);
    width: 100%;
    display: flex;
  }
  .card-category {
    background-color: black;
    padding: 5px 15px;
    font-size: 13px;
    border-radius: 20px;
    width: fit-content;
    margin-left: 10px;
    color: white;
  }
</style>
